export const TOAST_ERROR_MESSAGE = 'Something went wrong, please try again.';

export const POPUP_WINDOW_NAME = 'kubitPopupLogin';
